export enum EmailType {
  Authentication = "authentication",
  Quiz = "quiz",
}
